const getRefundReasonStatusLabel = reason => {
  switch (reason) {
    case 'duplicate':
      return 'Duplicate';
    case 'fraudulent':
      return 'Fraudulent';
    case 'requested_by_customer':
      return 'Requested by customer';
    default:
      return 'Unknown';
  }
};

export default getRefundReasonStatusLabel;
